<template>
  <div>
    <div class="home">
      <div>
        <p class="home-span">用户注册协议</p>
      </div>
    </div>
    <div class="box">
      <span class="box-1">用户注册协议</span>
      <div style="margin-top: 0.2rem">
        <p class="box-2">
          欢迎申请使用易易云教育科技有限公司（以下简称“易易云”）提供的【UKidSchool英语】软件及服务！
        </p>
      </div>
      <div>
        <p class="box-3">
          您在使用易易云提供的各项服务（以下简称“本服务”）之前，请您务必审慎阅读、充分理解并选择接受或不接受本服务协议（以下简称“本协议”）及《隐私政策》各条款内容，包括但不限于免除或者限制易易云的条款，特别是免除或限制责任的条款、争议解决和法律适用条款。阅读本协议的过程中，如果您不同意本协议或其中任意条款之约定，您应立即停止注册程序。
        </p>
        <p class="box-3" style="margin-top: 0.3rem">
          当您按照注册页面提示填写信息、阅读并同意本协议由且完成全部注册程序后，或您按照激活页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或您以其他“UKidSchool英语”软件允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容或者未获得“UKidSchool英语”软件对您问询的解答等理由，主张本协议无效，或要求撤销本协议。
        </p>
        <p class="box-3" style="margin-top: 0.3rem">
          本协议可由易易云随时更新，更新后的协议条款一旦公布即代替旧协议条款，易易云不再另行通知，您可在本软件查阅最新版协议条款。在易易云修改本协议条款后，如果您不接受修改后的条款，请立即停止使用易易云提供的服务，并通过文末的联系方式联系我们协商处理。本协议内容同时包括易易云可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
        </p>
        <p class="box-3" style="margin-top: 0.3rem">
          若您有问题，请通过文末的联系方式联系我们。
        </p>
        <p class="box-3" style="margin-top: 0.3rem">
          如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。
        </p>
      </div>
      <div>
        <p class="box-4">·一、协议的范围</p>
        <p class="box-5">1.协议主体</p>
        <p class="box-5">
          本协议是您与【UKidSchool英语】的经营者之间关于您下载、安装、使用、复制本软件，以及使用【UKidSchool英语】相关服务所订立的协议，对您与【UKidSchool英语】经营者均具有合同效力。
        </p>
        <p class="box-5">2.协议内容</p>
        <p class="box-5">
          <span>
            协议内容包括本协议正文及所有【UKidSchool英语】已经发布的或将来可能发布的各类协议、补充协议和规则。</span
          >【UKidSchool英语】有权根据需要不时地制定、修改本协议或各类规则，并在网站及APP上进行公布。经修订的协议一经公布后，立即自动生效，并成为本协议的一部分。<span>
            登录或继续使用本软件及服务将表示您接受经修订的协议。如您不同意相关变更，可以选择立即停止使用本软件及服务</span
          >。
        </p>
        <p class="box-4">·二、关于本服务</p>
        <p class="box-5">2.协议内容</p>
        <p class="box-5">
          <span>【UKidSchool英语】所提供的课程服务为线上课程视频服务</span
          >，在您使用【UKidSchool英语】相关课程服务时，请您仔细确认所选课程或服务的名称、适合年龄段等信息。【UKidSchool英语】可能会根据服务的整体规划，对服务相关权益细则、方式等进行修改和变更，前述修改、变更，【UKidSchool英语】将在相应服务页面（如课程详情页）进行展示。您若需要获取、使用【UKidSchool英语】会员服务，请先提前了解清楚会员激活、开通方式等信息，然后根据需要选择相应服务；<span
            >您激活开通【UKidSchool英语】会员服务，即意味着您已认可该项服务；您账号激活开通会员成功后，该项服务即时生效。</span
          >
        </p>
        <p class="box-4">·三、软件的安装、更新与卸载</p>
        <p class="box-5">
          1.您使用本服务需要下载【UKidSchool英语】客户端软件，【UKidSchool英语】授予您一项不可转让、非排他性的权利以使用本软件；你可以直接从官网上获取本软件，也可以从【UKidSchool英语】授权的第三方获取。您如果从未经授权的第三方获取本软件或与本软件名称相同的安装程序，【UKidSchool英语】无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。
        </p>
        <p class="box-5">
          2.为了提升您的使用体验，保证本软件及服务的安全性和功能的一致性，【UKidSchool英语】有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。新版本发布后，旧版本的软件可能存在全部或部分功能无法使用的情形，请您随时核对并下载最新版本。
        </p>
        <p class="box-4">·四、注册与使用</p>
        <p class="box-5">
          1.您在申请使用本软件时，应提供完整、真实、准确、最新的个人资料注册【UKidSchool英语】账号。如果您注册账号的信息发生变化，请您注意及时更改，并保证注册资料为用户本人的真实资料，不存在冒用他人身份或使用他人手机号码等进行注册的情况。如果因注册信息不真实或更新不及时或冒用行为等导致账号纠纷或引发相关问题，【UKidSchool英语】不承担责任。同时，如您违反本协议约定，【UKidSchool英语】有权根据实际情况选择不经通知单方采取临时封停、永久封停、注销登记、收回账号等措施。
        </p>
        <p class="box-5">
          2.【UKidSchool英语】帐号的所有权归【UKidSchool英语】所有，您完成申请注册手续后，仅获得帐号的使用权，您不得将账号进行转让、出借、出租、售卖或分享予他人使用，否则【UKidSchool英语】有权选择根据实际情况暂时封停或永久查封此账号。【UKidSchool英语】为了保障用户的账号安全可能会定期或不定期采用不同的方式对您的身份进行验证，包括但不限于要求输入验证码、短消息验证等。如您无法完成验证或拒绝验证的，【UKidSchool英语】可合理怀疑您的账号出现异常或被盗，并暂停向您提供服务或采取进一步措施。
        </p>
        <p class="box-5">
          3.您有责任妥善保管注册帐户信息及帐户登陆验证码的安全，并需要对注册帐户下的行为承担法律责任。您同意在任何情况下均不向他人透露帐户及登陆验证码信息。当您怀疑他人在使用你的帐号时，您应立即通知【UKidSchool英语】，否则未经授权的使用行为均视为您本人的行为。
        </p>
        <p class="box-5">
          4.您理解并同意，为了向您提供有效的服务，本软件会利用您终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。
        </p>
        <p class="box-5">
          5.您理解并同意，【UKidSchool英语】有权决定将本软件作商业用途，包括但不限于开发、使用本软件的部分服务为第三方作推广等，【UKidSchool英语】承诺在推广过程中严格按照本协议约定保护您的个人信息。
        </p>
        <p class="box-4">·五、用户使用规范</p>
        <p class="box-4">
          1. 您不得利用【UKidSchool英语】制作、复制、查阅和传播下列信息：
        </p>
        <p class="box-5">(1)反对宪法所确定的基本原则的；</p>
        <p class="box-5">
          (2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
        </p>
        <p class="box-5">(3)损害国家荣誉和利益的；</p>
        <p class="box-5">
          (4)歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
        </p>
        <p class="box-5">
          (5)宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
        </p>
        <p class="box-5">(6)煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p class="box-5">(8)散布谣言，扰乱经济秩序和社会秩序的；</p>
        <p class="box-5">
          (9)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
        </p>
        <p class="box-5">
          (10)侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
        </p>
        <p class="box-5">(11)使用夸张标题，内容与标题严重不符的</p>
        <p class="box-5">(12)炒作绯闻、丑闻、劣迹等的；</p>
        <p class="box-5">(13)不当评述自然灾害、重大事故等灾难的；</p>
        <p class="box-5">(14)带有性暗示、性挑逗等易使人产生性联想的；</p>
        <p class="box-5">(15)展现血腥、惊悚、残忍等致人身心不适的；</p>
        <p class="box-5">(16)煽动人群歧视、地域歧视等的</p>
        <p class="box-5">(17)宣扬低俗、庸俗、媚俗内容的；</p>
        <p class="box-5">
          (18)可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；
        </p>
        <p class="box-5">
          (19)其他违反法律、行政法规和国家规定禁止的其他内容。
        </p>
        <p class="box-5">
          2.
          您在使用【UKidSchool英语】课程服务的过程中，应遵守宪法、法律、行政法规和国家规定，包括但不限于《网络安全法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《信息网络传播权保护条例》等互联网规定的法律、法规，并禁止从事以下行为：
        </p>
        <p class="box-5">
          （1）从事违反法律法规政策、破坏公序良俗、损害公共利益的行为；
        </p>
        <p class="box-5">
          2）对本软件及内载相关信息擅自出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等，并发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；
        </p>
        <p class="box-5">
          （3）对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码等；
        </p>
        <p class="box-5">
          （4）修改、删除或避开应用产品中为保护知识产权而设置的任何技术措施，删除本软件及其副本上关于版权的信息、内容；
        </p>
        <p class="box-5">
          （5）利用【UKidSchool英语】帐号或本软件及服务发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，或从事欺诈、盗用他人账户、资金等违法犯罪活动；
        </p>
        <p class="box-5">
          （6）进行任何危害信息网络安全的行为，包括但不限于未经允许进入他人计算机系统删除、修改、增加存储信息；故意传播恶毒程序或病毒以破坏、干扰正常网络信息服务的行为；
        </p>
        <p class="box-5">
          （7）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
        </p>
        <p class="box-5">
          （8）提交、发布虚假信息，或冒充、利用他人名义的；虚构事实、隐瞒真相以误导、欺骗他人的；
        </p>
        <p class="box-5">
          （9）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；
        </p>
        <p class="box-5">
          （10）恶意攻击、辱骂、诽谤、骚扰【UKidSchool英语】工作人员、老师或【UKidSchool英语】的其他用户
        </p>
        <p class="box-5">
          （11）其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或【UKidSchool英语】未明示授权的行为。
        </p>
        <p class="box-4">
          3.您在使用【UKidSchool英语】服务时，以下行为属于违反使用规范：
        </p>
        <p class="box-4">（1）您以非法目的使用【UKidSchool英语】课程服务。</p>
        <p class="box-4">
          （2）您不以上课的真实交易为目的使用【UKidSchool英语】服务。
        </p>
        <p class="box-4">（3）您存在多次被投诉等不良记录的。</p>
        <p class="box-4">
          （4）您存在以非法下载、录屏、出售等方式侵犯【UKidSchool英语】或其他第三方知识产权等合法权益的行为。
          <br />
          您充分理解并同意：
        </p>
        <p class="box-4">
          （1）【UKidSchool英语】将对您是否涉嫌违反上述使用规范进行认定，并根据认定结果不经事先通知中止或终止向您提供服务或采取其他依约定可采取的限制措施；
        </p>
        <p class="box-4">
          （2）【UKidSchool英语】有权利直接删除您发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息；
        </p>
        <p class="box-4">
          （3）对于您违反上述使用规范的行为对任意第三方造成损害的，您需要以自己的名义独立承担法律责任，并应确保【UKidSchool英语】免于因此产生损失或增加费用；
        </p>
        <p class="box-4">
          （4）如您违反有关法律或本协议之约定，致任何第三方索赔，或给【UKidSchool英语】带来损失，或致行政管理部门处罚的，您应赔偿【UKidSchool英语】因此遭受的损失，包括合理的律师费用、调查取证等相关费用。
        </p>
        <p class="box-4">·六、隐私政策与数据</p>
        <p class="box-5">
          1.保护您个人信息是【UKidSchool英语】的一项基本原则，【UKidSchool英语】将会采取合理的措施保护您的个人信息。除法律法规规定的情形外，未经您的许可，【UKidSchool英语】不会向第三方公开、透露您的个人信息。【UKidSchool英语】对相关信息采用专业加密存储与传输方式，以保障您个人信息的安全。
        </p>
        <p class="box-5">
          2.您在注册帐号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供帐号注册服务或进行用户身份识别，需要您填写手机号码等。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。
        </p>
        <p class="box-5">
          3.一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
        </p>
        <p class="box-5">
          4.【UKidSchool英语】将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。
        </p>
        <p class="box-5">
          5.
          为服务用户的目的，【UKidSchool英语】可能通过使用您的个人信息，向您提供服务，包括但不限于向您发出产品和服务信息；未经您的同意，【UKidSchool英语】不会向UKidSchool英语以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定或本协议另有约定的除外。
        </p>
        <p class="box-4">
          6.【UKidSchool英语】非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用【UKidSchool英语】的服务前，应事先取得您家长或法定监护人的同意。
        </p>
        <p class="box-5">
          7.对于【UKidSchool英语】会如何收集、使用、存储和保护您的个人信息及您享有何种权利，您还可以阅读《UKidSchool英语隐私政策》、《UKidSchool英语儿童个人信息保护规则及监护人须知》予以进一步了解。
        </p>
        <p class="box-5">
          8.大众化学习资源推荐，在您使用平台学习资源时，平台默认按资源主题的级别、难易程度、内容前后关联关系以固定的排序从首页推荐给您使用。您也可以通过【学习区】-【主题区】自行任选主题内资源进行个性化学习使用。
        </p>
        <p class="box-4">·七、特别授权</p>
        <p class="box-5">
          <span>
            1.您将符号、文字、图片、视频、音频等信息上传【UKidSchool英语】将其公开发布、传播、分享的，您需享有信息的知识产权或取得第三方合法授权</span
          >。您充分了解并同意，【UKidSchool英语】提供的上传、分享、传播信息功能，仅用于您上传、分享、传送及获取信息，所传送的任何内容并不反映【UKidSchool英语】的观点或政策；同时，您应对其他用户提供的内容自行加以判断，并承担因使用该内容而引起的风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。
        </p>
        <p class="box-4">·八、终端安全责任</p>
        <p class="box-5">
          1.您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户自身原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用您的资料，进行现实中的骚扰；您下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。维护软件安全与正常使用是【UKidSchool英语】和您的共同责任，【UKidSchool英语】将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意【UKidSchool英语】并不能就此提供完全保证。若您发现有他人非法使用您的用户帐号的情况，或您的手机或其他有关设备丢失时，请您立即以有效方式通知【UKidSchool英语】；您还可以向【UKidSchool英语】申请暂停或停止相关服务。由于【UKidSchool英语】对您的请求采取行动需要合理时间，如【UKidSchool英语】未在合理时间内采取有效措施，导致您损失扩大的，【UKidSchool英语】将就扩大的损失部分承担责任，但【UKidSchool英语】对采取行动之前已执行的指令免于承担责任。
        </p>
        <p class="box-5">
          2.您不得制作、发布、使用、传播用于窃取【UKidSchool英语】帐号及他人个人信息、财产的恶意程序。
        </p>
        <p class="box-5">
          3.
          在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意【UKidSchool英语】有关防范诈骗犯罪的提示。
        </p>
        <p class="box-4">
          4.除本协议约定的【UKidSchool英语】可注销您账户的情形外，您可以电话联系客服400-0828-566（周一至周日9:00-21:00）说明注销需求，由【UKidSchool英语】注销该账户，账户注销后您即解除与【UKidSchool英语】协议关系；但注销该账号后，您的以下信息将被清空且无法找回：个人信息及账户信息、订单信息、学习记录、称号荣誉、U币等相关信息。如注销前您存在违法行为或违反本协议义务的，【UKidSchool英语】仍可行使本协议所规定的权利。
        </p>
        <p class="box-4">·九、第三方软件或技术</p>
        <p class="box-5">
          1.【UKidSchool英语】可能使用或包含了由第三方提供的软件或服务（以下称该等服务），该等服务是为了向您提供便利而设置，且已取得该第三方的合法授权。
        </p>
        <p class="box-5">
          2.由于第三方为其软件或服务的提供者，您使用该等服务时，应另行与该第三方达成服务协议，支付相应费用并承担可能的风险。<span>
            您应理解【UKidSchool英语】并无权在本协议中授予您使用该等服务的任何权利，也无权对该等服务提供任何形式的保证。【UKidSchool英语】无法对该等服务提供客户支持，如果您需要获取支持，您可直接与该第三方联系。因您使用该等服务引发的任何纠纷，您可直接与该第三方协商解决。</span
          >
        </p>
        <p class="box-5">
          3.您理解第三方需要与【UKidSchool英语】进行您的信息交互以便更好地为您提供服务，<span
            >您同意在使用本软件时如使用该等服务的，您授权【UKidSchool英语】依据《隐私保护政策》将您使用本软件的信息传递给该第三方，或从该第三方获取您注册或使用该等服务时提供或产生的信息。如果您不希望第三方获取您的信息的，您可停止使用该等服务，【UKidSchool英语】将停止向第三方传递您的信息。</span
          >
        </p>
        <p class="box-4">
          4.您同意，如果该第三方确认您违反了您与其之间关于使用该等服务的协议约定停止对您提供该等服务并要求【UKidSchool英语】处理的，由于停止该等服务可能会影响您继续使用本软件，【UKidSchool英语】可能会中止、终止对您的使用许可或采取其他依约可对您采取的限制措施。
        </p>
        <p class="box-4">·十、知识产权</p>
        <p class="box-5">
          1.【UKidSchool英语】是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件所包含的所有文字、图片、图标、用户界面、可视界面、界面设计、版面框架、商标、标识、声音、音乐、音频、视频、图表、有关数据或电子文档、美术作品及计算机编码（合称为“内容”），包括但不限于该等内容的设计、结构、选择、协调、表达、界面外观及排序等相关的所有信息内容均受中华人民共和国法律法规和相应的国际条约保护，【UKidSchool英语】享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
        </p>
        <p class="box-5">
          2.您仅基于自我学习的目的，享有使用【UKidSchool英语】服务的权利。未经【UKidSchool英语】或相关权利人书面同意，您不得对【UKidSchool英语】网站中包括但不限于音频、视频、文字、图片、软件等任何内容进行下载、录屏、复制、售卖等违反知识产权相关法律、法规的行为，也不得基于任何商业或非商业目的自行或许可任何第三方以实施、利用、转让等各种方式侵犯上述知识产权，或为出版或发行或为任何其他商业目的以任何方式将本软件的任何部分及任何内容复制、再制、重印、上传、发布、公开展示、编码、翻译、传输或散布至任何其他终端、网站或其他媒介。
        </p>
        <p class="box-4">·十一、服务的提供和中断</p>
        <p class="box-5">
          1.除法律法规另有明确规定外，【UKidSchool英语】将尽最大努力确保本软件及其所涉及的技术及信息安全、有效、准确、可靠，但受限于现有技术，您理解【UKidSchool英语】不能对此进行担保。您理解，对于不可抗力及第三方原因导致的您的直接或间接损失，【UKidSchool英语】无法承担责任。
        </p>
        <p class="box-5">
          2.您因下述任一非【UKidSchool英语】原因所引起或与此有关的人身伤害或附带的、间接的损害赔偿，包括但不限于利润、预期利益损失或其它商业损害赔偿或损失，需由您自行承担：（1）使用或未能使用本软件；（2）第三方未经批准的使用本软件或更改您的数据；（3）使用本软件进行的行为发生的费用及损失；（4）您对本软件的误解及非因【UKidSchool英语】的原因而引起的与本软件有关的其它损失
        </p>
        <p class="box-5">
          3.您应妥善保管自己的账号和密码，加强密码安全性，谨防账号泄露或被盗。因您自身原因导致账号被泄露或被盗而造成的任何损失，如账号、账号内财产等丢失、减少的，【UKidSchool英语】不承担补偿等责任。您因电信和网通部门的通讯线路故障、网络或电脑故障、系统不稳定、不可抗力（如服务器当机）等非【UKidSchool英语】原因造成账号、账号内财产等丢失、减少的，【UKidSchool英语】不承担补偿等责任。
        </p>
        <p class="box-4">·十二、协议终止和违约责任</p>
        <p class="box-5">
          1.您应理解按授权范围使用本软件、尊重软件及软件包含内容的知识产权、按规范使用本软件、按本协议约定履行义务是您获取【UKidSchool英语】授权使用软件的前提，如您严重违反本协议，【UKidSchool英语】有权终止本协议。
        </p>
        <p class="box-5">
          2.您对本软件的使用可能有赖于【UKidSchool英语】关联公司为您提供的配套服务，您违反与【UKidSchool英语】或其关联公司的条款、协议、规则、通告等相关规定，而被上述任一网站终止提供服务且可能导致您无法正常使用本软件的，【UKidSchool英语】有权终止本协议。
        </p>
        <p class="box-5">
          3.如您违反本协议规定的条款，给【UKidSchool英语】或其他第三方造成损失，您必须承担全部的赔偿责任。如【UKidSchool英语】承担了上述责任，则您同意赔偿【UKidSchool英语】的相关支出和损失，包括合理的律师费用。
        </p>
        <p class="box-4">
          4.如果【UKidSchool英语】发现或收到他人举报或投诉您违反本协议约定的，【UKidSchool英语】有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。
        </p>
        <p class="box-4">
          5.您理解并同意，【UKidSchool英语】有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。
        </p>
        <p class="box-4">
          6.您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；【UKidSchool英语】因此遭受损失的，您也应当一并赔偿。
        </p>
        <p class="box-4">·十三、法律适用和管辖</p>
        <p class="box-5">
          1.本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，如无相关法律规定的，则应参照通用国际商业惯例和（或）行业惯例。
        </p>
        <p class="box-4">
          2.若您和【UKidSchool英语】之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交青岛仲裁委员会根据其现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方都有约束力。仲裁费用由败诉一方承担。
        </p>
        <p class="box-5">
          3.本协议（含隐私保护政策）任何条款依据法律法规或被有管辖权的人民法院裁定为无效，不应影响其他条款或其任何部分的效力，您与【UKidSchool英语】仍应善意履行。
        </p>
        <p class="box-4">·十四、其他</p>
        <p class="box-5">
          1.【UKidSchool英语】可能根据业务调整而变更向您提供软件服务的主体，变更后的主体与您共同履行本协议并向您提供服务，以上变更不会影响您在本协议项下的权益。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。
        </p>
        <p class="box-5">
          2.本协议的所有标题仅仅是为了醒目及阅读方便，本身并没有实际涵义，不能作为解释本协议涵义的依据。
        </p>
        <p class="box-4">
          3.本协议可能存在包括中文、英文在内的多种语言的版本，如果存在中文版本与其他语言的版本相冲突的地方，以中文版本为准。
        </p>
        <p class="box-5">
          4、如果您对本协议有任何疑问、意见或建议，请通过以下方式与我们联系∶400-0828-566（周一至周日9:00-21:00）。
        </p>
        <p class="box-5">附件：《UKidSchool英语课程协议》</p>
        <p class="box-0">UKidSchool英语课程协议</p>
        <p class="box-5">
          UKidSchool英语课程协议<br />
          如有任何问题<br />
          请致电 400-0828-566 <br />
          或者联系您的课管员老师 <br />
          本协议中，“甲方”是指购买乙方相应课程的自然人；“乙方”是指“青岛易易云科技有限公司”。
        </p>
        <p class="box-4"> 第一部分  课程信息</p>
        <p class="box-5"> 课程基本信息：以乙方官方网站或指定官方平台（“乙方平台”）中甲方账号下的订单信息为准。</p>
        <p class="box-4"> 第二部分  课程服务</p>
        <p class="box-4"> 1.乙方依据本协议为报名UKidSchool英语课程的学员提供直播、点播教学课程服务。每节课的时长原则为 25 分钟。每节课为自适应的课程，因孩子的能力而延长或缩短上课时间，具体时长根据实际情况确定。</p>
        <p class="box-4"> 2.学员个人可通过课管员老师确认起始级别，平台根据课管员分配的班级级别配备相应课程内容，甲方及学员同意全部课程从该级别开始。</p>
        <p class="box-4"> 3.每次课程结束后,乙方有权将该次课程的视频录像上传至乙方平台,甲方可以在该次课程结束后登陆乙方平台查看课程视频。</p>
        <p class="box-4"> 4.甲方学员应在约定的会员有效期内完成课程的学习。有效期届满后会员权限自动失效，UKidSchool英语课程无法再学习，已支付的费用不再退还。</p>
        <p class="box-4"> 5.甲方购买的服务内容仅限于甲方学员自行使用，不能在不同的乙方平台账户之间转移。甲方不能就购买的内容进行复制、销售或进行其他传播行为</p>
        <p class="box-4"> 第三部分  双方的权利义务</p>
        <p class="box-4">1.甲方的权利和义务：</p>
        <p class="box-5">(1）甲方及学员不得发布反动、色情等违法信息，不得影响乙方平台的正常运营，不得影响课程进程及其他学员的学习活动，否则乙方有权暂停甲方课程账户的使用。</p>
        <p class="box-5">（2）甲方及学员在课程学习期内，如遇有任何问题，可以随时与乙方的工作人员取得联系。</p>
        <p class="box-5">（3）甲方及学员不得发布不实言论损害乙方或乙方员工的名誉。</p>
        <p class="box-5">（4）在任何情况下，甲方及学员应仅出于该学员个人使用之目的而使用账号或学习课程，不得以任何方式转让、出借、出租、售卖或分享予他人使用乙方提供的全部或部分课程服务。</p>
        <p class="box-5">（5）甲方同意自行配备宽带上网设备及其他学习乙方课程所需软件和硬件设备。</p>
        <p class="box-5">（6）甲方及学员未按本协议约定学习课程，导致出现影响其用户体验或学习效果等情形，应自行承担相关责任。</p>
        <p class="box-5">（7）为保护所有注册用户及学员的权益，甲方不得利用乙方平台搜集、探寻、索取其他甲方及学员的个人信息、联络方式（包括但不限于电子邮件信箱、QQ账号、微信账号、微博）、交友及财务状况等等。</p>
        <p class="box-4"> 2.乙方的权利和义务：</p>
        <p class="box-5">（1）在保证学习效果的前提下，乙方有权改进、调整或变更其学习内容、服务、课程安排或其他事项，但乙方应将上述任何变更通过网站或本协议中列明的联系方式及时通知甲方。</p>
        <p class="box-5">（2）乙方应根据甲方提出的要求，在约定范围内提供相应技术支持服务，并及时回应甲方提出的问题和意见。</p>
        <p class="box-5">（3）未经甲方许可，乙方不得发布甲方学员的音视频信息或学习状态。</p>
        <p class="box-4"> 第四部分  个人信息及保密</p>
        <p class="box-5">1.为便于乙方了解学员情况、更好地履行本协议项下义务，甲方向乙方提供学员的部分个人信息。乙方应注意依法严格保护学员的个人隐私。</p>
        <p class="box-5">2.如甲方提供的学员信息发生变更，甲方应及时通知乙方工作人员；由于甲方未及时通知而导致乙方无法联系到甲方，使学员的学习受到影响的，甲方应自行承担责任。</p>
        <p class="box-5">3.甲方同意应妥善保管其会员账户和信息，并对任何人利用其账户和信息所进行的活动负责。如学员的账户遭到未获授权的使用，或者发生其他任何安全问题，甲方应立即通知乙方的工作人员，要求乙方工作人员暂停相关服务。甲方亦不得将其账号和密码转让、出借、出租、售卖或分享予他人使用。如乙方合理怀疑甲方违反本约定，乙方有权暂时停止甲方账户之使用；如果乙方最终确认甲方违反本约定，乙方有权终止本协议，不再为甲方提供课程服务。</p>
        <p class="box-5"> 4.未经乙方书面同意及授权，甲方不得以任何方式将因本协议之订立或执行所得悉的乙方之技术数据、商业秘密及其他机密资料和信息提供给任何第三人或向第三人披露，如有违反，乙方有权立即终止本协议并要求甲方赔偿其损失。</p>
        <p class="box-4"> 第五部分  知识产权</p>
        <p class="box-4"> 1.以下所述资料的所有权及全部、完整的知识产权归乙方享有：</p>
        <p class="box-5">（1）乙方为所有课程所制作的全部资料（包括但不限于教材教辅、服务材料、课件及其他相关材料等）；</p>
        <p class="box-5">（2）在课程服务过程中产生的全部资料（包括但不限于任何视频、文档方案等）；</p>
        <p class="box-5">（3）乙方平台上所显示、使用或提供之软件、程序及内容。未经乙方同意，甲方及学员在任何时候（包括本协议有效期内及协议终止后）均不得：①为商业目的对上述资料进行利用；②以任何方式翻译、复制、传播、编辑上述资料；③将上述资料透露给任何第三方。</p>
        <p class="box-5"> 2.甲方同意，在甲方学员参与的所有课程中，或甲方及学员参与乙方组织、举办的其他活动中， 乙方可以进行拍照、摄像、录音、录像等记录活动。乙方对上述记录活动过程中所产生的作品、录音录像制品等单独地享有全部、完整的知识产权。乙方同意依法为甲方及学员的个人信息采取严格的保密措施。未经甲方同意，乙方不得将上述包含甲方及学员肖像或者显示个人身份的其他个人信息进行公开地商业使用。仅当以下情况之一发生时，乙方可以对甲方的肖像、姓名等个人信息进行合理使用，乙方无须再单独取得甲方同意，也无须向甲方支付任何费用：</p>
        <p class="box-5">（1）甲方及学员的肖像、姓名等合法民事权益，已被明确放弃；</p>
        <p class="box-5">（2）为乙方内部的展示/使用需要，在内部会议中展示、将相关资料作为历史档案留存于乙方档案库或者服务器上等。</p>
        <p class="box-4"> 第六部分  禁止劝诱</p>
        <p class="box-5"> 乙方的员工、老师（包括外教和中国老师）为其公司存续及发展的重要支撑力量，任何人非经乙方同意不得在使用乙方课程中及课程结束后，以任何方式劝诱、要求、或者邀请乙方的员工或者老师与乙方终止或者解除服务关系，或劝诱、要求、或者邀请乙方的员工或者老师接受由甲方自己或者甲方介绍的其他个人或组织提供（无论正式、兼职、或者临时组织的活动）的任何职务。 如有违反，甲方应当向乙方承担违约金，违约金的金额为上述人员离职前所在的乙方岗位上一年度年薪或报酬的两（2）倍。</p>
        <p class="box-5"> 第七部分  违约责任</p>
        <p class="box-5">1.本协议任何一方违约，均应承担违约责任，对另一方因此产生的损失承担赔偿责任。</p>
        <p class="box-5">2.如果乙方违约，甲方有权随时以通知乙方的方式终止本协议，并要求乙方按照本协议附件一约定的退款方式进行退款。给甲方造成损失的，乙方应当承担相应违约责任，乙方因未能履行本协议项下的义务而需承担的全部责任的上限为甲方学员支付的课程费用总额。</p>
        <p class="box-5">3.如果甲方违约，乙方有权随时以通知甲方的方式终止本协议；甲方的违约行为给乙方造成损失的，乙方有权先行在甲方已经支付但尚未使用的课程费用中扣除相应金额。</p>
        <p class="box-4"> 第八部分  不可抗力</p>
        <p class="box-4"> 1.“不可抗力”是指本协议双方不能合理控制、不可预见或即使预见亦无法避免的，且妨碍、影响或延误任何一方根据协议履行其全部或部分义务的事件。该事件包括但不限于自然灾害、政府行为、战争或任何其他类似的，且妨碍、影响或延误任何一方根据协议履行其全部或部分义务的事件。</p>
        <p class="box-4"> 2.任何一方遭受不可抗力事件可暂行中止履行本协议项下的义务直至不可抗力事件的影响消除为止，并且无需为此而承担违约责任；但应尽最大努力克服该事件，减轻其负面影响。</p>
        <p class="box-4"> 3.甲方确认：因以下情形造成乙方平台不可用或甲方学员使用课程服务的数据丢失、毁损的，不属于乙方违约，乙方在法律允许范围内不承担责任：</p>
        <p class="box-5">（1）因定期检查或施工，更新维护软硬件而造成的服务中断，或突发性的软硬件设备与电子通信设备故障；</p>
        <p class="box-5">（2）因甲方使用不当所造成的服务不可用</p>
        <p class="box-5">（3）黑客、病毒、电信部门技术调整等引起的事件。</p>
        <p class="box-4"> 4.因国家法律政策法规调整、行政干预，或由于火灾、地震、战争等不可抗力因素而影响本协议履行时，双方均不承担违约责任。</p>
        <p class="box-4"> 第九部分  其他事项</p>
        <p class="box-4"> 1.在甲方的会员到期结束后，本协议自动终止，甲方所拥有的会员账号同时失效。但本协议的终止不影响第五部分、第六部分和第七部分有关保密、知识产权及禁止劝诱条款的效力。</p>
        <p class="box-4"> 2.乙方有权不时根据法律、法规、政策以及课程和管理改进的需要对本协议及乙方平台的内容进行修改，并在乙方平台中公布。修改后的该等协议一经公布立即生效，并代替原来的协议，乙方无需另行通知甲方可随时登录查阅最新协议。如甲方不同意更新后的协议，应立即书面通知乙方并立即停止接受乙方依据本协议提供的服务；如甲方未在2个工作日内书面通知乙方或用户继续使用乙方提供的服务的，即视为同意更新后的协议。</p>
        <p class="box-4"> 3.协议经甲方确认并同意后，将以电子文件方式留存于乙方系统中，作为双方协议签署及遵循的依据。</p>
        <p class="box-4"> 4.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
        <p class="box-4"> 第十部分  法律管辖和争议解决</p>
        <p class="box-4"> 1.本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律（不包括特别行政区及台湾地区法律）。</p>
        <p class="box-4"> 2.协议中未尽事宜，双方依据乙方公司平台的公示内容为准。因本协议引起的或与本协议有关的任何争议， 双方应当首先友好协商解决。协商不成，双方同意将争议提交至青岛仲裁委员会根据其现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方都有约束力。仲裁费用由败诉一方承担。</p>
        <p class="box-5"> 青岛易易云科技有限公司 </p>
        <p class="box-5" style="margin-top: 0rem;"> 2020年11月28日 </p>


      </div>
    </div>
  </div>
</template>

<script>
import "../css/home.css";
import rem from "../utils/rem";
export default {
  name: "Home",
  components: {},
};
</script>
